import React, { useEffect, useState } from "react";

import { Row, Col, Tabs, Tab } from "react-bootstrap"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
    faSquare
} from "@fortawesome/free-solid-svg-icons"
import { ECHARTS_COLORS } from '../../constants/echarts-colors.constants';
import DoughnutChart from "./DoughnutChart";
import Link from "next/link"

const focusItems = [
    { name: "categories" },
    { name: "subcategories" },
    { name: "platforms" },
    { name: "industries" },
]

const focusTags = {
    industries: {
        title: "Industry focus",
        label: "Target industries"
    },
    categories: {
        title: "Core services",
        label: "Core services"
    },
    subcategories: {
        title: "",
        label: "Focus areas"
    },
    platforms: {
        title: "",
        label: "Technology stacks"
    }
};

//--
const sumArr = (items) => {
    let initialValue = 0
    return items.reduce(
        (accumulator, currentValue) => accumulator + (currentValue.percent || initialValue), initialValue);
}

//--
const CompanyFocus = (props) => {
    const focusData = props.data;
    const categories = props.data.categories?.CAT || [];

    const [selectedOption, setSelectedOption] = useState();
    const [selectedItems, setSelectedItems] = useState([]);

    const selectOption = (tabKey, dataKey) => {
        const selectedDataKey = dataKey ?? Object.keys(focusData[tabKey])[0];

        if (selectedDataKey) {
            const items = focusData[tabKey][selectedDataKey];

            let colors = ECHARTS_COLORS.concat([]);

            const getColor = () => {
                const first = colors.shift();
                colors.push(first);
                return first;
            }

            items.forEach((e) => e.color = getColor());

            setSelectedOption(selectedDataKey);
            setSelectedItems(items);
        }
    }

    useEffect(() => {
        selectOption(focusItems[0].name);
    }, []);

    return (
        <div id="speciality" className="text-block">
            <h4 className="mb-4">Speciality</h4>
            <Tabs id="fill-tab-example-456" onSelect={(e) => selectOption(e)}>
                {focusItems.map((focus, index) => (
                    (Object.keys(focusData[focus.name]).length > 0) && (
                        <Tab
                            key={index}
                            eventKey={focus.name}
                            title={focusTags[focus.name].label}
                            className="p-3 p-lg-1"
                        >
                            <Row className="mt-2 d-flex flex-column flex-md-row gap-5 gap-md-2">
                                <Col className="col-12 col-md-6 col-lg-5">
                                    <DoughnutChart items={selectedItems ?? []} />
                                </Col>
                                <Col>
                                    <ChartSelect
                                        focusData={focusData[focus.name]}
                                        focusName={focus.name}
                                        categories={categories}
                                        selectOption={selectOption}
                                        selectedOption={selectedOption}
                                    />
                                    {FocusItemList(selectedItems)}
                                </Col>
                            </Row>
                        </Tab>
                    )
                ))}
            </Tabs>
        </div>
    )
}

const ChartSelect = (props) => {
    const { selectOption, selectedOption, focusData, focusName, categories } = props;

    const getGroupLabel = (name, groupvalue) => {
        const label = (['subcategories', 'platforms'].includes(name))
            ? categories.find((category) => category.value === groupvalue)?.label || ""
            : ""
        return label;
    };

    const getChartLabel = (data, focusName, groupLabel) => {
        const label = focusTags[focusName].label;

        const arrLables = ['Target industries', 'Core services', 'Focus areas', 'Technology stacks'];
        const arrLablesRep = ['Target industry', 'Core service', 'Focus area', 'Technology stack'];
        const index = arrLables.findIndex(f => f === label);
        const frmLabel = ((data.length === 1) && (index >= 0)) ? arrLablesRep[index] : label;

        return `${data.length} ${frmLabel} ${groupLabel && ` in ${groupLabel}`}`;
    }

    const data = Object.keys(focusData);

    return data.length > 1 ? (
        <select className="form-select" value={selectedOption} onChange={(e) => selectOption(focusName, e.target.value)}>
            {data.map((key) => (
                <option key={key} value={key} className="text-sm">
                    {getChartLabel(focusData[key], focusName, getGroupLabel(focusName, key))}
                </option>
            ))}
        </select>
    ) : null;
}

//--
const FocusItemList = (items) => {
    return (
        <ul className="list-unstyled mt-3">
            {items.map((item, index) =>
                <li key={index}>
                    <FontAwesomeIcon
                        icon={faSquare}
                        style={{ color: item.color }}
                        className="w-1rem me-2 text-center"
                    />
                    {item.url ?
                        (
                            <Link href={`/companies/${item.url}`}>
                                <a className="text-muted">
                                    {item.label}
                                </a>
                            </Link>
                        ) :
                        (<span className="text-muted">{item.label}</span>)
                    }
                    <span className="text-muted float-end">{`${item.percent}%`}</span>
                </li>
            )}
        </ul>
    )
}

export default CompanyFocus;
